import React from "react";
import SheetEditor from "./SheetEditor.jsx";
import RememberedDetails from "./RememberedDetails.jsx";
import { Status } from "./Fields.jsx";
import { numberLabel, orderNumberLabel } from "../../utils/consolidationPresentation.js";
import { ConsolidationOrderTargets } from "../../hooks/useConsolidationOrderTargets.js";

export default function ManualOrderSheets({ sheets, editorProps }) {
  const targets = React.useContext(ConsolidationOrderTargets);
  const arrival = React.useRef("");
  React.useEffect(() => {
    if (!targets.arrival || arrival.current === targets.arrival) return;
    for (const sheet of sheets) {
      if (!sheet.visits.some(v => v.orders.some(o => targets.ids.has(o.label)))) continue;
      const panel = document.getElementById(sheet.id ? `sheet-${sheet.id}` : `manual-order-${sheet.manual_order_id}`);
      if (panel) { panel.open = true; arrival.current = targets.arrival; }
    }
  }, [sheets, targets.arrival, targets.ids]);
  return <div className="grid min-w-0 gap-2">{sheets.map(sheet => {
    const order = sheet.visits.flatMap(visit => visit.orders).find(item => item.id === sheet.manual_order_id);
    if (!order) return null;
    return <RememberedDetails key={sheet.source_key || sheet.id} stateKey={`manual:${sheet.source_key}`}
      id={sheet.id ? `sheet-${sheet.id}` : `manual-order-${order.id}`} data-consolidation-target-unassigned={targets.ids.has(order.label)}
      className={`min-w-0 rounded-[4px] border border-slate-200 bg-white p-2 ${targets.ids.has(order.label) ? "ring-1 ring-amber-400" : ""}`}>
      <summary className="cursor-pointer text-xs"><span className="ml-1 inline-flex max-w-full flex-wrap items-center gap-x-3 gap-y-1 align-middle">
        <strong title={order.label}>{orderNumberLabel(order.label)}</strong><span>{order.client_name}</span><span className="text-slate-600">{order.coop || order.mill?.name || order.source_mill?.name || "Meunerie à associer"}</span>
        <span className="whitespace-nowrap">{numberLabel(order.planned_tons, 3)} t prévues</span><Status value={sheet.id ? sheet.status : "expected"} />
      </span></summary>
      <div className="mt-2 min-w-0"><SheetEditor initial={sheet} embedded {...editorProps} /></div>
    </RememberedDetails>;
  })}</div>;
}
